<agpr-dialog-container
    [id]="id + '.publishStoryDialog'"
    [showClose]="closableStatus"
    [contentPadding]="false"
    (close)="cancel()"
    [heading]="header"
>
    <div class="agpr-publishDialogue">
        <agpr-scroll-panel>
            <div class="agpr-publishDialogue-header">
                <div class="agpr-publishDialogue-headerIcon {{ headerIcon }}" aria-hidden="true"></div>
                <div class="agpr-publishDialogue-heading">
                    <div class="agpr-publishDialogue-headingTitle">{{ localization.headerTitle | localize }}</div>
                    <p class="agpr-publishDialogue-headingSubtitle">{{ localization.headerSubTitle | localize }}</p>
                </div>
            </div>

            <div class="agpr-publishDialogue-info" *ngIf="storyInfo">
                <div class="agpr-publishDialogue-infoWrapper" *ngFor="let meta of metadata">
                    <div class="agpr-publishDialogue-infoWrapperType">{{ meta.label  | localize }}</div>
                    <div class="agpr-publishDialogue-infoWrapperData">
                        <p *ngIf="!meta.customTemplate && !meta.isUrl">
                            {{ meta.value }}
                        </p>
                        <a
                            *ngIf="!meta.customTemplate && meta.isUrl"
                            [href]="meta.value"
                            class="agpr-publishDialogue-infoWrapperData-url"
                            target="_blank"
                        >
                            {{ meta.value }}
                        </a>
                        <ng-container *ngIf="meta.customTemplate">
                            <ng-template *ngFor="let value of meta.value"
                                [ngTemplateOutlet]="meta.customTemplate"
                                [ngTemplateOutletContext]="{$implicit: value}"
                            ></ng-template>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="agpr-publishDialogue-disclaimers">
                <ng-template ngFor let-i="index" let-disclaimer [ngForOf]="disclaimers">
                    <div *ngIf="i >= 1" class='agpr-publishDialogue-disclaimerSeparator'></div>
                    <div>
                        <div class="agpr-publishDialogue-disclaimerConfirmation">
                            <div>
                                <a
                                    *ngIf="guideline"
                                    class="agpr-publishDialogue-disclaimerConfirmationGuideline"
                                    id="publishStory.disclaimerGuidelineLink"
                                    target="_blank"
                                    href="http://help.agilitypr.com/amplify/agility-newsroom-editorial-guidelines"
                                >
                                    {{guideline | localize}}
                                </a>
                            </div>
                            <agpr-checkbox
                                id="publishStory_iAgreeCheckbox"
                                [binary]="true"
                                [label]="disclaimer | localize"
                                [disabled]="!closableStatus"
                                [(ngModel)]="disclaimerStatuses[i]"y
                                (onChange)="getIAgreeStatus()"
                            >
                            </agpr-checkbox>
                        </div>
                    </div>
                </ng-template>
            </div>
        </agpr-scroll-panel>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            id="publishStory.cancelButton"
            [label]="localization.cancel"
            (click)="cancel()"
            [style]="buttonTypes.secondary"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            *ngIf="showPublishButton"
            id="publishStory.agreedAndPublishButton"
            [label]="localization.agreePublish"
            [disabled]="!iAgree"
            [loading]="showPublishLoader"
            [style]="buttonTypes.primary"
            (click)="onPublishClick()"
        ></agpr-button>
    </ng-template>

</agpr-dialog-container>
